import { User } from "views/settings-users/types";

export enum NotificationKind {
  Mention = "mention"
}
export enum NotificationType {
  TaskMention = "mentioned_in_tasks",
  ApplicationNotesMention = "mentioned_in_application_notes",
  LeadNotesMention = "mentioned_in_lead_notes",
  AssignedTask = "task_assigned",
  DueTask = "task_due_soon"
}
export interface Notification {
  id: number;
  kind: NotificationKind;
  created_at: string;
  type: NotificationType;
  user: User;
  author?: User | string;
  read_at: string | null;
  url: string;
  updated_at: string;
  rich_text: {
    document_html: string;
    document_text: string;
  };
  metadata: {
    rich_text_id?: number;
    application_id?: number | null;
    rich_text_field: "title" | "description";
    note_id?: number;
    task_id?: number | null;
  };
}

export interface NotificationGroup {
  name: string;
  items: Notification[];
}
